import React, { useState, useEffect } from 'react';
import {MyDashboardItemGray} from "../../styles/MyStyles";
import {GetIsBlocked} from "../../logic/JwtExtractor";
import {Typography} from "@mui/material";

const ClockDashboardItem = () => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000); // Update every 1 second

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const formattedTime = currentTime.toLocaleTimeString();
    const formattedDate = `${currentTime.getDate()}/${currentTime.getMonth()}/${currentTime.getFullYear()}`;
    const formattedWeekDay = currentTime.getDay();

    return (
        <MyDashboardItemGray>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography style={{ fontWeight: 'bold' }}>
                    {formattedTime} ; {formattedDate} ; {days[formattedWeekDay]}
                </Typography>
                {GetIsBlocked() === 'False' ? (
                    <Typography style={{ fontWeight: 'bold', color: 'green' }}>
                        {'Your user is Active'}
                    </Typography>
                ) : (
                    <Typography style={{ fontWeight: 'bold', color: 'red' }}>
                        {'Your user is Blocked'}
                    </Typography>
                )}
            </div>
        </MyDashboardItemGray>
    );
};

export default ClockDashboardItem;
